import { Injectable } from '@angular/core';
import { EipConnection, EipMessageListener } from './eip.connection';
import { EipMessages } from './eip.messages';
import { EipContext } from './eip.context';
import { EipStorage } from './eip.storage';
import { EipUser } from './eip.model';
import { EipConfig } from '@schir-int-client/api-root';

// @Deprecated: wahrscheinlich zu streichen, da createDigitalFile aus dem Backend gerufen wird.
@Injectable({ providedIn: 'root' })
export class EipDigitalFile implements EipMessageListener {
	private config: EipConfig;

	constructor(
		private context: EipContext,
		public storage: EipStorage,
		private connection: EipConnection
	) {}

	init(config: EipConfig) {
		this.config = config;
		this.connection.addMessageListener(this);
	}

	public sendCreateDigitalFile() {
		const user: EipUser = this.context.currentUser();

		console.log('sendCreateDigitalFile for %o', user);

		this.connection.sendMessage(EipMessages.createDigitalFileRequest(user, this.config));
	}

	public onMessage(messageName: string, messageObj: any, id: string) {
		switch (messageName) {
			case 'CreateDigitalFileResponse':
				this.onCreateDigitalFileResponse(messageObj);
				break;
			default:
				console.log('eIP-DigitalFile: unknown message type: ' + messageName);
		}
	}

	public supportedMessageNames(): string[] {
		return ['CreateDigitalFileResponse'];
	}

	private onCreateDigitalFileResponse(messageObj: any) {
		console.log('onCreateDigitalFileResponse: ' + messageObj);
	}
}
